import { Label } from "../../atoms/RTCC/label";
import useMedia from 'use-media'
import './../../../resources/RTCC/css/footer/footer.css';

export const FooterContainer = (props) => {

    const isWideTablet = useMedia({ maxWidth: '960px' });
    const isWidePhone = useMedia({ maxWidth: '480px' });

    return (
        <div>
            <Label label={"COPYRIGHT © RESORTTRUST ALL RIGHTS RESERVED."} className={isWideTablet ? "footerLabel2" : "footerLabel1"} />
        </div>
    )
    
};
